import { ApiErrorResponseWithCode } from '@vfde-sails/utils';

/** Validate object by requiredKeys array */
export const validateObject = (requiredKeys: {key: string, type: string}[], obj: Object): boolean => {
    return requiredKeys.every(prop => {
        if (!(prop.key in obj)) {
            return false;
        }

        if (typeof obj[prop.key as keyof Object] !== prop.type) {
            return false;
        }

        return true;
    });
};

export const isEmpty = (obj: any) =>
    obj
    && 0 === Object.keys(obj).length
    && Object.getPrototypeOf(obj) === Object.prototype;

export const isApiError = (error: unknown): error is ApiErrorResponseWithCode => {
    return null !== error
        && 'object' === typeof error
        && 'constructor' in error
        && error.constructor.name === ApiErrorResponseWithCode.name;
};
